/** Centralized TanStack Query keys - never inline a key in a screen. */

export const queryKeys = {
  competitions: ['competitions'] as const,
  competition: (id: string) => ['competitions', id] as const,
  fixturesForDay: (dayKey: string) => ['fixtures', 'day', dayKey] as const,
  liveFixtures: ['fixtures', 'live'] as const,
  fixturesByCompetition: (competitionId: string, scope: string) =>
    ['fixtures', 'competition', competitionId, scope] as const,
  competitionSeasonFixtures: (competitionId: string, season: number) =>
    ['fixtures', 'comp-season', competitionId, season] as const,
  fixture: (id: string) => ['fixtures', 'detail', id] as const,
  matchEvents: (fixtureId: string) => ['match-events', fixtureId] as const,
  playerMatchStats: (fixtureId: string) => ['player-match-stats', fixtureId] as const,
  matchXg: (fixtureId: string) => ['match-xg', fixtureId] as const,
  liveMatchStats: (fixtureId: string) => ['live-match-stats', fixtureId] as const,
  playerCards: (afKey: string) => ['player-cards', afKey] as const,
  standings: (competitionId: string, season: number) =>
    ['standings', competitionId, season] as const,
  headToHead: (teamA: string, teamB: string) => ['fixtures', 'h2h', teamA, teamB] as const,
  teams: (competitionId: string) => ['teams', competitionId] as const,
  allTeams: ['teams', 'all'] as const,
  team: (id: string) => ['teams', 'detail', id] as const,
  teamPlayers: (teamId: string) => ['players', 'team', teamId] as const,
  player: (id: string) => ['players', 'detail', id] as const,
  playerSeason: (playerId: string) => ['players', 'season', playerId] as const,
  scores365Athlete: (nameNorm: string) => ['scores-365', 'athlete', nameNorm] as const,
  scores365Player: (athleteId: number) => ['scores-365', 'player', athleteId] as const,
  topScorers: (competitionId: string, season: number) =>
    ['top-scorers', competitionId, season] as const,
  search: (query: string) => ['search', query] as const,
  profile: (userId: string) => ['profile', userId] as const,
  favorites: (userId: string) => ['favorites', userId] as const,
  fantasySeasons: ['fantasy', 'seasons'] as const,
  fantasySeason: (id: string) => ['fantasy', 'seasons', id] as const,
  gameweeks: (fantasySeasonId: string) => ['fantasy', 'gameweeks', fantasySeasonId] as const,
  myFantasyTeams: (userId: string) => ['fantasy', 'my-teams', userId] as const,
  myFantasyTeam: (fantasySeasonId: string, userId: string) =>
    ['fantasy', 'my-team', fantasySeasonId, userId] as const,
  squadPicks: (fantasyTeamId: string) => ['fantasy', 'picks', fantasyTeamId] as const,
  fantasyPlayerPool: (competitionId: string) => ['fantasy', 'pool', competitionId] as const,
  playerGwScores: (gameweekId: string) => ['fantasy', 'gw-scores', gameweekId] as const,
  teamGwScore: (fantasyTeamId: string, gameweekId: string) =>
    ['fantasy', 'team-gw-score', fantasyTeamId, gameweekId] as const,
  lineupHistory: (fantasyTeamId: string, gameweekId: string) =>
    ['fantasy', 'lineup-history', fantasyTeamId, gameweekId] as const,
  overallLeaderboard: (fantasySeasonId: string) =>
    ['fantasy', 'leaderboard', fantasySeasonId] as const,
  myRank: (fantasySeasonId: string) => ['fantasy', 'my-rank', fantasySeasonId] as const,
  myMiniLeagues: (userId: string) => ['fantasy', 'mini-leagues', userId] as const,
  miniLeagueLeaderboard: (leagueId: string) =>
    ['fantasy', 'mini-league-board', leagueId] as const,
  publicSquad: (fantasyTeamId: string) => ['fantasy', 'public-squad', fantasyTeamId] as const,
  teamChips: (fantasyTeamId: string) => ['fantasy', 'chips', fantasyTeamId] as const,
  sportsEvents: (sport: string, mode: string) => ['sports', sport, mode] as const,
  scores365: (sportId: number, mode: string, date?: string) =>
    ['scores-365', sportId, mode, date ?? 'today'] as const,
  bzzoiroWsToken: ['bzzoiro', 'ws-token'] as const,
  wcNews: (fixtureId: string) => ['wc-news', fixtureId] as const,
  competitionHistory: (providerId: number) => ['competition-history', providerId] as const,
  scores365Standings: (providerId: number) => ['scores-365', 'standings', providerId] as const,
  scores365Bracket: (providerId: number) => ['scores-365', 'bracket', providerId] as const,
  h2h365: (gameId: number) => ['scores-365', 'h2h', gameId] as const,
  weeklyChallenges: (userId: string) => ['predict-weekly', 'challenges', userId] as const,
  coinsLeaderboard: ['predict-weekly', 'coins-board'] as const,
  appConfig: ['app-config'] as const,
} as const;
